import { Link } from "@mui/material";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { OpenTabsContext } from "../OpenTabsContext";
import useNotify from "../unit/useNotify";

const CustomerIdLinkIdField = ({ ...props }) => {
  const id = props.id;
  const name = props.name;
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const navigate = useNavigate();
  const { openGlobalTabs } = useContext(OpenTabsContext);

  const handleClick = (id: any) => {
    if (openGlobalTabs.length >= 6) {
      if (openGlobalTabs.includes("customer-" + id + "-")) {
        navigate(`/userSummary/` + id);
      } else {
        errorNotify("Cannot open more than 6 tabs.");
        return false;
      }
    } else {
      navigate(`/userSummary/` + id);
    }
  };
  return (
    <Link
      component="span"
      onClick={() => handleClick(id)}
      className="numericText"
      underline="none"
      sx={{
        "&.MuiLink-root": { color: "#1976d2" },
        cursor: "pointer",
        textDecoration: "none",
        "&.RaLink-link": {
          color: "#1976d2",
        },
        "&:hover": {
          textDecoration: "underline",
        },
      }}
    >
      {name ? name : id}
    </Link>
  );
};

export default CustomerIdLinkIdField;
